import React from "react";

const LineOutsideContext = React.createContext<[any, Function]>([{}, ()=>{}]);
const SavedPlacesContext = React.createContext<[any, Function]>([[], ()=>{}]);
const RecentPlacesContext = React.createContext<[any, Function]>([[], ()=>{}]);
const SubscribedPlacesContext = React.createContext<[any, Function]>([[], ()=>{}]);
const AlertsConfigContext = React.createContext<[any, Function]>([[], ()=>{}]);

export { LineOutsideContext, SavedPlacesContext, RecentPlacesContext, SubscribedPlacesContext, AlertsConfigContext }